import { render, staticRenderFns } from "./AssignWindowView.vue?vue&type=template&id=6d8ed362&scoped=true&"
import script from "./AssignWindowView.vue?vue&type=script&lang=js&"
export * from "./AssignWindowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ed362",
  null
  
)

export default component.exports